module.exports = __webpack_public_path__ + "assets/a2eb029929b7f4e96eaddd415f129252.mp3";